import { useQuery } from "@tanstack/react-query";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectLoggedInUserId } from "../../../../store/user/user-selector";
import { getAxios } from "../../../Services/commonService";
import DataTable from "../../DataTable";
import { SucceededFailedBadge } from "../../UI/Badge";
import DateUtils from "../../../../utils/dateUtils";
import { useNavigate } from "react-router-dom";
import Icon from "../../../../assets/icons/Icon";

const LoginHistoryModal = ({ rowData }) => {
  const navigate = useNavigate();
  const LoggedInUserId = useSelector(selectLoggedInUserId);
  const [currentPageSize, setCurrentPageSize] = useState(50);

  const { data, isLoading } = useQuery({
    queryKey: ["login-history", LoggedInUserId, rowData?.id, currentPageSize],
    queryFn: async () => {
      const res = await getAxios("/usersession/history", {
        userId: rowData?.id,
        pageSize: currentPageSize,
      });

      return res?.items || [];
    },
    enabled: !!LoggedInUserId,
  });

  const columns = useMemo(
    () => [
      { accessorKey: "loginByName", header: "Login Name" },
      {
        accessorKey: "isLoginSuccess",
        header: "Status",
        cell: ({ getValue }) => <SucceededFailedBadge getValue={getValue} />,
        enableSorting: true,
      },
      {
        accessorKey: "loginTime",
        header: "Login Time",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
        enableSorting: true,
      },
      {
        accessorKey: "logoutTime",
        header: "Logout Time",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
        enableSorting: true,
      },
      { accessorKey: "ipAddress", header: "IP Address", enableSorting: true },
      { accessorKey: "deviceId", header: "Device Id", enableSorting: true },
      { accessorKey: "deviceType", header: "Device Type", enableSorting: true },
      { accessorKey: "browser", header: "Browser", enableSorting: true },
      { accessorKey: "os", header: "OS", enableSorting: true },
    ],
    [],
  );

  const handlePageSizeChange = (size) => {
    setCurrentPageSize(size);
  };

  const handleLoginHistoryDetail = () => {
    navigate("/management/login-history", {
      state: { rowData },
    });
    return;
  };

  return (
    <>
      <div
        className="history-alert"
        role="note"
        aria-label="Login history details"
      >
        <Icon className="history-alert__icon" name="TriangleAlert" size={13} />
        <p className="history-alert__text">
          Showing records from the last 7 days. For advanced details and
          filters, click
        </p>
        <button
          type="button"
          onClick={handleLoginHistoryDetail}
          className="cursor-pointer history-alert__action"
        >
          More.
        </button>
      </div>
      <DataTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        isPagination={false}
        isPageSize={true}
        onRecordsPerPageChange={handlePageSizeChange}
      />
    </>
  );
};

export default LoginHistoryModal;
